<template>
  <!-- 账号密码截图 -->
  <div class="page_win accountPwd">
    <div class="topContent">
      <div class="topContent_m">
        <span>账号信息</span>
      </div>
      <div class="closeBtn" @click="closeWin">
        <img :src="closeImg" />
      </div>
    </div>
    <div class="content">
      <div class="textRow">
        <span>账号：</span><span class="text_r">{{ userInfo.uname }}</span>
      </div>
      <div class="textRow">
        <span>密码：</span
        ><span class="text_r">{{ $store.state.registerPwd }}</span>
      </div>
      <div class="textRow">
        <span>请截图保留手机相册</span>
      </div>
    </div>
    <div class="bot_btn" @click="closeWin">进入游戏</div>
  </div>
</template>
<script>
export default {
  props: ["isShowContact", "isCloseBtn"],
  inject: ["reload"],
  data() {
    return {
      userInfo: "",
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
    };
  },
  creater() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    // 关闭当前窗口
    closeWin: function () {
      this.$store.dispatch("IsAccountAndPasFun", false);
      if(this.userInfo.loginFcm==1 || this.userInfo.loginFcm==2){
        this.$store.dispatch("IsReconiseInfoFun",true);
      }
      this.reload();
      //不知道为什么关闭当前窗口这里要价格刷新，刷新也没关系，刷了会重新判断已登陆的账号有没有开启强制实名 一样会过滤
      //此处刷新是为了刷新游戏登录地址中的用户id，不刷新的话会用默认加载背景时所使用的临时id
    },
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}

.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
}
.topContent_m,
.closeBtn {
  @include flex_box(row, center, center);
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #ff913a;
    line-height: 0.68rem;
  }
}
.closeBtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 0.8rem;
  height: 0.68rem;
  justify-content: flex-end;
  img {
    width: 0.3rem;
  }
}

.content {
  margin: 0.4rem 0 .3rem;
  color: #838383;
  @include flex_box(column, center, center);
  .textRow {
    margin: 0.1rem 0;
    height: 0.34rem;
    @include flex_box(row, center, center);
    color: #838383;
  }
  .text_r{
    color:#ff913a ;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view8/accountAndPas.vue